<template>
  <div class="supplierEntryList" v-loading="supplierLoad">
    <div class="noData" v-show="nodata">
      <div class="noDataCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/noData.png" alt="">
        <p>暂无数据</p>
      </div>
    </div>
    <ul class="clearfix" v-show="!nodata">
      <li class="col-xs-12 col-sm-12 col-md-6 col-lg-6" v-for="(item,index) in supplierEntryInfo" :key="index">
        <div :class="item.storageStatus == 1?'supplierEntryBg clearfix supplierEntryIcon':item.storageStatus == 2?'supplierEntryBg clearfix supplierEntryIcon_ing':'supplierEntryBg clearfix'">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-4 imgBox"><img :src="item.logoUrl" alt=""></div>
          <div class="col-xs-9 col-sm-9 col-md-9 col-lg-8 pull-right supplierEntryCon">
            <h4><a :href="viewSupplierUrl + item.supplierId" target="_blank">{{item.supplierName}}</a></h4>
            <p>
              <span v-for='(service,index) in item.serviceDetails' :key="index">[{{service}}]</span>
            </p>
            <div class="supplierEntryBtn hidden-xs hidden-sm clearfix" v-if="item.storageStatus == 0||item.storageStatus == 3">
              <button type="button" class="btn btn-primary pull-left col-md-4" @click="veryfyAdd(item.supplierId,warehousingUrl, item, $event)">添加入库</button>
              <button type="button" class="btn btn-default pull-left col-md-4" v-show="item.collectionStatus==0" @click="addCollect(item.supplierId, item, $event)">添加关注</button>
              <button type="button" class="btn btn-default pull-left col-md-4" v-show="item.collectionStatus==1"  @click="cancelCollect(item.supplierId)">取消关注</button>
            </div>
            <div class="supplierEntryBtn  hidden-xs hidden-sm clearfix" v-if="item.storageStatus == 2">
              <button type="button" class="btn btn-primary pull-left col-md-4" @click="viewExamine(item.contentId,viewExamineUrl)">查看审批流程</button>
            </div>
            <div class="supplierEntryBtn  hidden-xs hidden-sm clearfix" v-if="item.storageStatus == 1">
              <button type="button" class="btn btn-primary pull-left col-md-4" @click="goEnterpriseResource(item.supplierId,goEnterpriseResourceUrl)">到企业资源库查看</button>
            </div>
          </div>
        </div>
      </li>
      
      <!--li标签里面的div 类名为supplierEntryIcon 已准入 类名为supplierEntryBg没有准入-->
  
      <!--<li class="col-xs-12 col-sm-12 col-md-6 col-lg-6" v-for="(item,index) in supplierEntryInfo" :key="index">-->
        <!--<div class="supplierEntryIcon clearfix">-->
          <!--<div class="pull-left"><img :src="item.logoUrl" alt=""></div>-->
          <!--<div class="supplierEntryCon">-->
            <!--<h4>{{item.supplierName}}</h4>-->
            <!--<p>-->
              <!--<span v-for='(service,index) in item.serviceDetails' :key="index">[{{service}}]</span>-->
            <!--</p>-->
            <!--<div class="supplierEntryBtn  hidden-xs hidden-sm clearfix">-->
              <!--<button type="button" class="btn btn-primary pull-left col-md-4" @click="veryfyAdd(item.supplierId,warehousingUrl)">添加入库</button>-->
              <!--<button type="button" class="btn btn-default pull-left col-md-4" v-show="item.collectionStatus==0" @click="addCollect(item.supplierId)">添加收藏</button>-->
              <!--<button type="button" class="btn btn-default pull-left col-md-4" v-show="item.collectionStatus==1"  @click="cancelCollect(item.supplierId)">取消收藏</button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</li>-->
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {customAddInStorag, customAddConcern} from '@/assets/js/sensors'

export default {
  props: ['supplierEntryInfo','warehousingUrl','viewExamineUrl','goEnterpriseResourceUrl','hitSearchUrl','supplierLoad','nodata','viewSupplierUrl'],
  data () {
    return {
      verifyFalg:false,
      userInfo:{},
      companyInfo:{},
      orgId:'',
      checkFlag:true,
      accessToken:'',
      orgIdentity:[],
      orgIdentityStr:'',
      rowsResult:{},
      userTag:'',
      regeisterType:''
    }
  },
  computed: mapState([
    'KP'
  ]),
  created () {
    if(this.getToken('isLogin') == 100){
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
      this.orgId  = this.companyInfo.orgId;
      this.orgIdentityStr = this.companyInfo.orgIdentity;
      if(this.orgIdentityStr !=''){
        this.orgIdentity = this.orgIdentityStr.split(",");
      }
      this.regeisterType = this.userInfo.regeisterType;
      this.userTag = this.userInfo.userTag;
    }
  },
  methods: {
    jump(supplierName,hitSearchUrl){
      window.location.href = hitSearchUrl + supplierName;
    },
    goEnterpriseResource(supplierId,goEnterpriseResourceUrl){
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
      }
      else{
        // this.checkFlag = this.(this.orgId);
        // if(!this.checkFlag){
        //   this.$router.push({path:'/inforPerfection'});
        // }else{
        this.$axios.post('/onelink.mdata.main.api/supplier/verifyExt', {
          currOrgIdentity: this.orgIdentity,
          currPurchaserId: this.orgId,
          currTrueName: this.userInfo.trueName,
          currUid: this.userInfo.id
        }).then((res) => {
          
          this.rowsResult = res.data.data.rowsResult;
          if(this.rowsResult.success == false){
            this.$message({
                  message: this.rowsResult.errorMsg,
                  type: 'error'
            });
          }else{
            window.location.href = goEnterpriseResourceUrl+supplierId;
          }
          
          
        }).catch((err) => {
            console.log(err)
        })
      }
    },
    viewExamine(supplierId,viewExamineUrl){
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/login'});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
      }
      else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }else{

        this.$axios.post('/onelink.mdata.main.api/supplier/verifyExt', {
          currOrgIdentity: this.orgIdentity,
          currPurchaserId: this.orgId,
          currTrueName: this.userInfo.trueName,
          currUid: this.userInfo.id
        }).then((res) => {
          this.rowsResult = res.data.data.rowsResult;
          if(this.rowsResult.success == false){
            this.$message({
                  message: this.rowsResult.errorMsg,
                  type: 'error'
            });
          }else{
            window.location.href = viewExamineUrl+supplierId;
          }
          
          
        }).catch((err) => {
            console.log(err)
        })
      }
    },
    veryfyAdd(supplierId,warehousingUrl, item){
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
      }
      else{
 
        this.$axios.post('/onelink.mdata.main.api/supplier/verifyExt', {
          currOrgIdentity: this.orgIdentity,
          currPurchaserId: this.orgId,
          currTrueName: this.userInfo.trueName,
          currUid: this.userInfo.id
        }).then((res) => {
            this.rowsResult = res.data.data.rowsResult;
            if(this.rowsResult.errorMsg !=''){
              this.$message({
                    message: this.rowsResult.errorMsg,
                    type: 'error'
              });
            }else{
              window.location.href = warehousingUrl+supplierId;
            }
          
        }).catch((err) => {
            console.log(err)
        })
      }

      // 埋点
      try {
        customAddInStorag({
          position: "门户",
          org_id: item.supplierId,
          org_name: item.supplierName,
          org_credit: null
        })
      } catch (e) {console.log(e)}
    },
    addCollect(supplierId, item){
      // this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
     if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
      }
      else{
        this.$axios.post('/onelink.mdata.main.api/supplier/addCollect', {
          currOrgIdentity: [
            "10","20"
          ],
          currPurchaserId: this.orgId,
          currTrueName: this.userInfo.trueName,
          currUid: this.userInfo.id,
          supplierId:supplierId
        }).then((res) => {
          if(res.data.success == true){
            this.$message({
                message: "添加关注成功!",
                type: 'success'
            });
            this.supplierEntryInfo.forEach(element => {
              element.collectionStatus = 1;
            });
          }else{
            this.$message({
                message: "添加关注失败!",
                type: 'error'
            });
          }
        }).catch((err) => {
            console.log(err)
        })
      }
      // 埋点
      try {
        customAddConcern({
          position: "门户",
          org_id: item.supplierId,
          org_name: item.supplierName,
          org_credit: null
        })
      } catch (e) {console.log(e)}
    },
    cancelCollect(supplierId){
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
            cancelButtonText: '以后再说',
            confirmButtonText: '点我补全',
            center: true
          }).then(() => {
            this.$router.push({path:'/inforPerfection'});
          }).catch(() => {
              this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
              }).then((res) => {
                this.data = res.data;
                this.removeCookie('TALK_LATER_'+this.data.userId);
                this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
              });
          });
      }
      else{
        let isEnableDeleteContent = "是否确认把所选企业从【我关注的供应商】中删除?";
        this.$confirm(isEnableDeleteContent, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          this.$axios.post('/onelink.mdata.main.api/supplier/cancalCollect', {
            currOrgIdentity: [
              "10","20"
            ],
            currPurchaserId: this.orgId,
            currTrueName: this.userInfo.trueName,
            currUid: this.userInfo.id,
            supplierId:supplierId
          }).then((res) => {
            if(res.data.success == true){
              this.$message({
                message: "取消关注成功!",
                type: 'success'
              });
              this.supplierEntryInfo.forEach(element => {
                element.collectionStatus = 0;
              });
            }else{
              this.$message({
                message: "取消关注失败!",
                type: 'error'
              });
            }
          }).catch((err) => {
              console.log(err)
          })
        })
      }
    }


  }
  
}
</script>



// WEBPACK FOOTER //
// src/components/supplierEntryList/index.vue